<script>
  import { onMount } from "svelte";
  import { ArrowLeft } from 'lucide-svelte';

  export let showModal = false;
  export let close;
  export let useBack = false;
  export let useClose = false;
  export let useCancelByEsc = true;
  export let title;
  export let zIndex = 1000;
  export let width = null;
  export let id = null;

  const handleKeydown = (event) => {
    if (showModal && useCancelByEsc && event.key === "Escape") {
      close();
    }
  };

  let mousedownOnBackdrop = false;

  function handleBackdropMousedown(e) {
    mousedownOnBackdrop = e.target === e.currentTarget;
  }

  function handleBackdropClick(e) {
    if (mousedownOnBackdrop && e.target === e.currentTarget) {
      close();
    }
    mousedownOnBackdrop = false;
  }

  onMount(() => {
    window.addEventListener("keydown", handleKeydown);

    // 컴포넌트가 언마운트될 때 리스너 제거
    return () => {
      window.removeEventListener("keydown", handleKeydown);
    };
  });
</script>

{#if showModal}
  <div
    class="modal-backdrop"
    role="button"
    tabindex="-1"
    aria-label="모달 닫기"
    on:mousedown={handleBackdropMousedown}
    on:click={handleBackdropClick}
    on:keydown={handleKeydown}
    style="z-index: {zIndex};"
    id={id ? `${id}-backdrop` : undefined}
  >
    <div class="modal-content" role="dialog" aria-modal="true" style={width ? `width: ${width}; max-width: 90vw;` : ''} id={id ? `${id}-content` : undefined}>
      <div class="modal-header" class:has-title={title || useBack}>
        <div class="modal-header-left">
          {#if useBack}
            <button class="textButton" on:click={close}
              ><ArrowLeft /></button
            >
          {/if}
          {#if title}
            <h2>{title}</h2>
          {/if}
        </div>
        <div class="modal-header-right">
          <slot name="headerActions" />
          {#if useClose}
            <button type="button" class="close-btn" id={id ? `${id}-btn-close` : undefined} on:click={close}>✕</button>
          {/if}
        </div>
      </div>
      <slot />
    </div>
  </div>
{/if}

<style>
  .modal-backdrop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
  }

  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 5px;
    max-width: 90vw;
    max-height: 90vh;
    overflow-y: auto;
    /* 모달 내부 스크롤이 끝에 닿아도 배경 페이지로 전파(scroll chaining)되지 않게 한다 */
    overscroll-behavior: contain;
    margin: auto;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .modal-header.has-title {
    margin-bottom: 1.25rem;
  }

  .modal-header-left {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .modal-header-right {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  h2 {
    font-size: 1.1rem;
    font-weight: 700;
    color: #1a1a1a;
    margin: 0;
  }

  .close-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: #888;
    padding: 0.2rem 0.4rem;
    line-height: 1;
    border-radius: 3px;
  }

  .close-btn:hover {
    color: #333;
    background: #f0f0f0;
  }

  /* 모바일 반응형 스타일 */
  @media (max-width: 768px) {
    .modal-backdrop {
      padding: 0.5rem;
    }

    .modal-content {
      max-width: 95vw;
      max-height: 95vh;
      padding: 1rem;
      width: 100%;
    }
  }

  @media (max-width: 480px) {
    .modal-backdrop {
      padding: 0.25rem;
      align-items: flex-start;
      padding-top: 2rem;
    }

    .modal-content {
      max-width: 98vw;
      max-height: 90vh;
      padding: 0.75rem;
      border-radius: 8px;
    }
  }
</style>
